import { ArrowRight, Check } from "lucide-react";
import { SERVICES_DETAIL } from "@/data/services";
import { Reveal } from "@/components/Reveal";
import { Process } from "@/sections/Process";
import { FinalCTA } from "@/sections/FinalCTA";

export default function ServicesPage() {
  return (
    <main data-testid="services-page" className="pt-32 lg:pt-40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="mono text-[11px] tracking-[0.28em] uppercase text-neutral-500 mb-5">Services</p>
          <h1 className="font-display font-bold tracking-tight text-neutral-50 text-4xl sm:text-5xl lg:text-6xl">
            What we do
          </h1>
          <p className="text-neutral-400 mt-6 max-w-xl text-base sm:text-lg leading-relaxed">
            Digital experiences designed around your business, your customers and where you want to go next.
          </p>
        </Reveal>

        <div className="mt-16 lg:mt-20 space-y-6">
          {SERVICES_DETAIL.map((s) => (
            <Reveal key={s.n}>
              <div
                data-testid={`service-detail-${s.n}`}
                className="rounded-2xl border border-white/[0.07] bg-white/[0.02] p-8 lg:p-12 grid lg:grid-cols-12 gap-10"
              >
                <div className="lg:col-span-5">
                  <div className="flex items-center gap-4">
                    <span className="w-11 h-11 rounded-lg border border-white/10 flex items-center justify-center text-neutral-300">
                      <s.icon size={20} strokeWidth={1.5} />
                    </span>
                    <span className="mono text-xs text-neutral-600 tracking-[0.2em]">{s.n}</span>
                  </div>
                  <h2 className="font-display text-2xl lg:text-3xl font-bold tracking-tight text-neutral-50 mt-8">
                    {s.title}
                  </h2>
                  <p className="text-neutral-400 text-sm leading-relaxed mt-3">{s.text}</p>
                  <p className="mt-8">
                    <span className="mono text-[10px] uppercase tracking-[0.22em] text-neutral-500 block mb-2.5">
                      Who this is for
                    </span>
                    <span className="text-sm text-neutral-200 leading-relaxed">{s.who}</span>
                  </p>
                </div>
                <div className="lg:col-span-7 lg:border-l lg:border-white/5 lg:pl-10">
                  <p className="mono text-[10px] uppercase tracking-[0.22em] text-neutral-500">The process</p>
                  <div className="flex flex-wrap items-center gap-2 mt-4">
                    {s.process.map((step, j) => (
                      <span key={step} className="flex items-center gap-2">
                        <span className="mono text-[10px] uppercase tracking-[0.15em] text-neutral-200 border border-white/10 rounded-full px-3 py-1.5">
                          {step}
                        </span>
                        {j < s.process.length - 1 && <ArrowRight size={12} className="text-neutral-600" />}
                      </span>
                    ))}
                  </div>
                  <p className="mono text-[10px] uppercase tracking-[0.22em] text-neutral-500 mt-9">
                    What's included
                  </p>
                  <ul className="mt-4 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                    {s.included.map((item) => (
                      <li key={item} className="flex items-start gap-2.5 text-sm text-neutral-300 leading-relaxed">
                        <Check size={14} className="text-neutral-500 mt-0.5 shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <Process />
      <FinalCTA />
    </main>
  );
}
